/// <reference types="vite/client" />
import * as Sentry from "@sentry/react";
import type { FailedRequest } from "./src/hooks/useApi";

async function probeHost(baseUrl: string): Promise<string> {
    try {
        const response = await fetch(`${baseUrl}/health`, { signal: AbortSignal.timeout(5000) });
        return String(response.status);
    } catch (err: any) {
        return err.name === 'TimeoutError' ? 'timeout' : `failed: ${err.message}`;
    }
}

if (import.meta.env.MODE === 'production') {
    // Initialize Sentry
    Sentry.init({
        dsn: 'https://06e1ea7844cc84657e6458cac36b5d47@o4510328986075136.ingest.de.sentry.io/4510328987910224',
        replaysSessionSampleRate: 0.0,  // set >0.0 to enable session replays
        environment: import.meta.env.MODE,
        async beforeSend(event, hint) {
            const failedRequest = (hint.originalException as { failedRequest?: FailedRequest } | undefined)?.failedRequest;
            if (failedRequest) {
                const [api, slowApi] = await Promise.all([
                    probeHost(import.meta.env.VITE_API_BASE_URL),
                    probeHost(import.meta.env.VITE_SLOW_API_BASE_URL),
                ]);
                event.contexts = { ...event.contexts, fetch_failure: { ...failedRequest, online: navigator.onLine, probes: { api, slowApi } } };
            }
            return event;
        },
    });
}
